import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M96.41 81.0399C93.08 78.5899 88.93 76.6399 91.68 61.0699C93.56 50.4499 93.76 34.7799 86.06 20.7099C78.4 6.70994 64.75 -2.6201 53.34 2.6699C41.93 -2.6301 28.28 6.70994 20.62 20.7099C12.92 34.7699 13.01 50.4599 15 61.0699C17.61 75.0199 14.17 76.56 10.84 79.01C7.51004 81.46 0.600034 86.6199 2.21003 93.2199C3.70003 99.3299 10.28 98.9399 10.28 98.9399C11.45 108.92 26.57 109.36 32.28 101.84C38.63 93.4699 33.32 77.38 29.99 67.39C26.66 57.4 28.95 44.7699 28.95 44.7699C29.16 50.0699 31.66 53.74 31.66 53.74L34.16 43.5499C34.16 43.5499 35.62 45.3799 36.45 44.7699C37.28 44.1599 44.78 37.8399 44.78 37.8399L45.82 39.4699C47.63 38.8399 50.74 38.4899 53.36 38.2899C55.97 38.4899 59.09 38.8499 60.9 39.4699L61.94 37.8399C61.94 37.8399 69.43 44.1599 70.27 44.7699C71.1 45.3799 72.56 43.5499 72.56 43.5499L75.06 53.74C75.06 53.74 77.56 50.0699 77.77 44.7699C77.77 44.7699 80.45 54.93 76.73 67.39C73.72 77.48 67.57 93.8899 74.44 101.84C81.31 109.79 94.53 107.16 96.5 99.39C96.5 99.39 103.04 99.9699 104.22 93.7999C105.46 87.1499 99.2 83.0999 96.41 81.0399Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M60.8801 38.8999C63.3801 11.7599 52.8301 3.71997 52.8301 3.71997C52.8301 3.71997 62.5101 3.86991 68.3701 13.4099C75.8701 25.6299 72.5301 43.01 72.5301 43.01"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M52.8401 3.72003C52.8401 3.72003 68.6901 2.11003 78.3701 18.34C87.6101 33.83 91.14 55.8 84.41 73.02C78.31 88.63 78.56 94.88 81.91 97.69C85.86 100.99 93.4801 97.47 92.9401 91.32C92.9401 91.32 98.3501 95.64 95.4401 100.98"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M71.47 20.01C71.47 20.01 84.23 31.3099 82.53 54.3199C81.3 70.9499 74.43 80.95 74.85 93.08C75.27 105.21 84.7 106.78 87.61 106.58"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M97.2684 90.1045C97.0961 89.5378 96.8742 88.9866 96.6126 88.4528C96.9091 88.967 97.1688 89.5044 97.3823 90.0668C97.7175 90.9575 97.9379 91.8907 97.9102 92.876L97.9101 92.8806C97.9013 93.3478 97.8044 93.8428 97.6016 94.3203C97.4688 94.6178 97.2642 94.9037 97.006 95.1429L96.7801 94.7229C97.2623 94.2794 97.5439 93.5766 97.5983 92.8423C97.6853 91.9383 97.5297 90.9927 97.2697 90.1089L97.2697 90.1089L97.2684 90.1045Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M45.81 38.8999C43.31 11.7599 52.84 3.71997 52.84 3.71997C52.84 3.71997 44.72 3.87991 38.32 13.4099C29.66 26.3199 34.1599 43.01 34.1599 43.01"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M52.98 3.27993C52.98 3.27993 39.04 1.36999 28.33 18.34C18.37 34.12 17.04 55.8 23.05 72.68C28.68 88.48 27.75 95.13 24.22 97.48C20.7 99.83 14.1 98.5099 13.22 91.8999C13.22 91.8999 8.68999 96.6799 11.61 102.02"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.91 23.09C33.91 23.09 22.76 36.2999 24.17 54.3199C25.47 70.9399 31.98 81.5299 31.57 93.6599C31.16 105.79 22.16 107.22 19.25 107.01"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M9.31394 93.3828C9.54302 94.1212 9.99497 94.7876 10.5621 95.2277L10.3381 95.6441C9.64814 95.0714 9.21935 94.2903 9.01463 93.4866L9.0138 93.4834C8.75748 92.5039 8.7838 91.473 9.04255 90.5212L9.04286 90.52C9.22034 89.8608 9.49511 89.2469 9.84226 88.6788C9.53222 89.2656 9.29925 89.8882 9.16996 90.5408C8.97446 91.4876 9.01568 92.4846 9.31394 93.3828Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M52.8401 3.71997C52.8401 3.71997 57.54 13.1099 54.6 38.0499"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
